import { SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import { ParticipantsDataTable } from "@/components/participants/participants.data-table";
import { useSuspenseQuery } from "@tanstack/react-query";
import { participantsApi } from "@/services/participants/participants.api";
import { $fetch } from "@/lib/fetch";
import { participantsDtoSchema, type Participant } from "slde-api/dto-schemas";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { ScanLogsDialog } from "@/components/scan-logs/scan-logs-dialog";
import { Download, Loader2 } from "lucide-react";
import React from "react";

export default function ParticipantsPage() {
  const [logsParticipant, setLogsParticipant] = useState<Participant | null>(null);
  const [isExporting, setIsExporting] = React.useState(false);

  async function handleExport() {
    setIsExporting(true);
    try {
      const token = localStorage.getItem("auth-token") ?? "";
      const baseUrl = (process.env.BUN_PUBLIC_API_URL ?? "").replace(/\/$/, "");
      const res = await fetch(`${baseUrl}/${participantsApi.participants.exportRoute()}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const csv = await res.text();
      const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "uczestnicy.csv";
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setIsExporting(false);
    }
  }

  const {
    data: { items },
  } = useSuspenseQuery({
    queryKey: participantsApi.participants.queryKey(),
    queryFn: async () =>
      await $fetch(participantsApi.participants.route(), {
        output: participantsDtoSchema,
        throw: true,
      }),
  });

  return (
    <div>
      <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
        <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
          <SidebarTrigger className="-ml-1" />
          <Separator
            orientation="vertical"
            className="mx-2 data-[orientation=vertical]:h-4"
          />
          <h1 className="text-base font-medium">Zarządzanie uczestnikami</h1>
          <div className="ml-auto flex items-center gap-2">
            <Button onClick={handleExport} disabled={isExporting}>
              {isExporting ? <Loader2 className="animate-spin" /> : <Download />}
              Eksportuj CSV
            </Button>
          </div>
        </div>
      </header>

      <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
        <ParticipantsDataTable
          data={items}
          actions={{
            onLogsClick: (p) => setLogsParticipant(p),
          }}
        />
      </div>
      <ScanLogsDialog
        filter={
          logsParticipant
            ? {
                type: "participant",
                identifier: logsParticipant.identifier,
                title: `${logsParticipant.firstName} ${logsParticipant.lastName}`,
              }
            : null
        }
        onClose={() => setLogsParticipant(null)}
      />
    </div>
  );
}
